module.exports = __webpack_public_path__ + "img/app-landing-awesome-bg-small.87685052.png";